<template>
    <li class="item" v-if="itemData">
        <div
            :class="[
                'action',
                isStretch ? '' : 'noAction',
                itemData.important === 'yes' ? 'iNewsList_active' : '',
            ]"
            @click="handleClickIsStretch(itemData)"
        >
            <span v-if="itemData.label_kind == '1'" class="i_type">[热门]</span>
            <template v-else>
                <span
                    v-if="itemData.state2 && itemData.label_kind != '1'"
                    class="i_type"
                    >[置顶]</span
                >
                <span v-else class="i_type">{{
                    getTimeType(itemData.label_kind, itemData.rec_time_desc)
                }}</span>
            </template>
            <span v-html="itemData.content"></span>
        </div>
        <!--  <div :class="itemData.image_1||itemData.image_2||itemData.image_3? 'multimedia' : '' ">
          <img :class="`preview-itemData-${randomStr}`" :src="`${citemData}`" alt="图片" />
          <img v-if="itemData.image_1" click="imagePopShow(itemData.image, 0)" :src="itemData.image_1" alt="" />
          <img v-if="itemData.image_2" click="imagePopShow(itemData.image, 1)" :src="itemData.image_2" alt="" />
          <img v-if="itemData.image_3" click="imagePopShow(itemData.image, 2)" :src="itemData.image_1&&itemData.image_2&&itemData.video.video_img?'':itemData.image_3" alt="" />
      </div> -->
        <div
            :class="gitClass(itemData.image)"
            v-if="
                (itemData.image && itemData.image.length) ||
                (itemData.video && itemData.video.video_img)
            "
        >
            <div
                class="vedio_img"
                v-if="itemData.video && itemData.video.video_img"
            >
                <span class="vedio_image">
                    <img
                        class="vedio_image_img"
                        :src="itemData.video.video_img"
                        alt=""
                    />
                    <!-- todo -->
                    <p @click="clickPlay(itemData.video.video)">
                        <img
                            class="vedio_play"
                            src="https://cdn.aigupiao.com/static/wrap/img/media_play_ico.png"
                            alt=""
                        />
                        <span class="vedio_time ub align-items">
                            <img
                                class="vedio_time_icon"
                                src="https://cdn.aigupiao.com/static/wrap/img/small_video_ico1.png"
                                alt=""
                            />
                            <i>{{ itemData.video.video_len }}s</i>
                        </span>
                    </p>
                </span>
            </div>
            <img
                v-for="(citemData, cindex) in itemData.image"
                v-bind:key="cindex"
                :preview="randomStr"
                v-lazy="`${citemData}`"
                alt="图片"
            />
        </div>

        <div class="import_deepReadding ub">
            <a v-if="itemData.o_title" @click="jumptolive(itemData)">
                <img
                    src="https://cdn.aigupiao.com/static/wrap/img/deep_link_ico1.png"
                    alt=""
                />
                {{ itemData.o_title }}</a
            >
            <div
                v-if="itemData.live_msg_id > 0 && type !== 'iNewsList'"
                @click="
                    hanleClickToPage(`/Lives/detail/id/${itemData.id}.html`)
                "
                class="stock_pool"
            >
                <div class="stock_pool_head">
                    <img :src="stock_pool" alt="" />
                    <span>{{ itemData.live_msg_head }}</span>
                </div>
                <div>
                    <img
                        :src="require('@/assets/images//mohu@2x.png')"
                        alt=""
                    />
                    <img class="img_two" :src="mohu" alt="" />
                </div>
                <span class="stock_pool_foot">详情 ></span>
            </div>
            <p class="import_readding ub-f1">
                <span
                    @click="
                        hanleClickToPage(`/express/detail/id/${itemData.id}`)
                    "
                    >阅&nbsp;{{ itemData.view_num }}</span
                >
                <a
                    class="important_comment"
                    @click="
                        hanleClickToPage(
                            `/express/detail/id/${itemData.id}/jump_type/2.html`
                        )
                    "
                >
                    <img
                        src="http://static-img-1251605428.file.myqcloud.com/mobile/gray_talk_icon.png"
                        alt=""
                    />
                    <span class="comment-num">{{ itemData.comment_num }}</span>
                </a>
            </p>
        </div>
    </li>
</template>
<script>
import stock_pool from "@/assets/images/stock_pool2x.png";
import mohu from "@/assets/images/mohu@2x.png";
export default {
    name: "importNewsItem",
    props: {
        itemData: {
            type: Object,
            default: {},
        },
        type: String,
    },
    data() {
        return {
            stock_pool,
            mohu,
            isStretch: false,
            randomStr: Math.random().toString(36).slice(-4),
        };
    },
    created() {},
    methods: {
        getTimeType(type, time) {
            switch (type) {
                case 0:
                    return time;
                case 1:
                    return "热门";
                default:
                    return time;
            }
        },
        selectAlbumItem(data, index, className) {
            // this.$photoswipe.open(index, data, className)
        },
        clickPlay(src) {
            this.$videoplay.open(src);
            // this.props.importantNews.vedioUrl = vedioUrl
            // this.props.importantNews.vedioPlay = true
        },
        gitClass(images) {
            if (images.length === 3) {
                return "multimedia space-between";
            } else {
                return "multimedia";
            }
        },
        jumptolive(item) {
            // this.pushLink(`/news/detail/id/${ item.o_id }`)
            // this.props.history.push(`/liveDetail/${id}`)
            if (item.liver_msg_id) {
                window.location.href = `/Lives/detail/id/${item.liver_msg_id}`;
            } else {
                window.location.href = `/news/detail/id/${item.o_id}`;
            }
            //跳转老项目
            // window.location.href = `/Lives/detail/id/${ item.o_id }` //跳转老项目
        },
        handleClickIsStretch(item) {
            this.isStretch = !this.isStretch;
            this.$emit("handleClickIsStretch", item);
            // this.$set(this.columnStore[index], `isStretch`, !item.isStretch)
        },
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.border-1px(@color: #e6e6e6, @radius: 0px, @style: solid) {
    position: relative;

    &::after {
        content: "";
        pointer-events: none;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        border-bottom: 1px @style @color;
        border-radius: @radius;
        box-sizing: border-box;
        width: 100%;
        height: 100%;

        @media (min-resolution: 2dppx) {
            width: 200%;
            height: 200%;
            border-radius: @radius * 2;
            transform: scale(0.5);
        }

        @media (min-resolution: 3dppx) {
            width: 300%;
            height: 300%;
            border-radius: @radius * 3;
            transform: scale(0.333);
        }
    }
}
.iNewsList_active {
    color: #c7000a;
}
li.item {
    margin-bottom: 10px;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 10px;
    // text-align: justify;
    .border-1px(#e6e6e6);

    &:last-child:after {
        border-bottom: none;
    }
    &:last-child {
        margin-bottom: 0;
        border-bottom: none;
    }
    .action {
        width: 100%;
        font-size: 16px;
        // text-align: justify;
        overflow: hidden;
        min-height: 32px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        line-height: 22px;
        .i_type {
            display: inline-block;
            margin-right: 5px;
            color: #c7000a;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            font-size: 16px;
        }
        &.noAction {
            //最多3行显示
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-height: 22px;
        }
    }

    div:nth-of-type(2) {
        display: flex;
        align-items: center;

        video {
            width: 31%;
            height: 100%;
        }

        img {
            // width: 100px;
            width: 31%;
            height: 100%;
        }
    }

    .import_deepReadding {
        width: 100%;
        position: relative;

        > a {
            color: #1d88d0;
            font-size: 12px;
            display: flex;
            align-items: center;
            margin-top: 7px;
            font-family: PingFangSC-Regular;
            font-weight: 400;

            > img {
                width: 12px;
                height: 13px;
                margin-right: 1px;
            }
        }

        .import_readding {
            margin-top: 7px;
            text-align: right;
            color: #939393;
            font-family: PingFang-SC-Medium;
            font-weight: 400;
            font-size: 12px;
            padding-top: 0 !important;

            span {
                margin-right: 26px;
            }
            span.comment-num {
                margin-right: 0;
                vertical-align: middle;
            }
            .important_comment {
                color: #939393 !important;
                display: inline-block;
                line-height: 12px;
                margin-right: 1px !important;
                > img {
                    margin-right: 7px;
                    width: 13px;
                    height: 12px;
                    display: inline-block;
                    vertical-align: middle;
                }
            }
        }
    }
}
.contain {
    padding: 10px 14px 0 14px;
    background-color: #ffffff;

    // ul {
    // }
}

.active {
    color: #c7000a;
}

.multimedia {
    height: 100px;
    margin-top: 7px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;

    div {
        margin-right: 10px;
    }
    &.space-between {
        > img {
            margin-right: 0;
        }
    }

    > img {
        width: 31%;
        margin-right: 10px;
    }
}

.stock_pool {
    margin: 11px 0 13px 0;
    width: 100%;
    height: 32px;
    background-color: #fbf7f3;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .stock_pool_head {
        font-size: 12px;
        color: #5b5b5b;
        width: 96px;
        height: 14px;
        letter-spacing: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 4px 0 6px !important;

        > img {
            width: 13px;
            height: 14px;
        }

        span {
            height: 14px;
            line-height: 14px;
        }
    }

    .stock_pool_foot {
        width: 60px;
        height: 14px;
        font-size: 12px;
        text-align: right;
        line-height: 14px;
        display: inline-block;
        color: #5b5b5b;
        margin-right: 9px;
    }

    > div {
        width: 200px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;

        > img {
            // width: 100px;
            height: 100%;
        }

        @media screen and (max-width: 410px) {
            .img_two {
                display: none;
            }
        }
    }
}

//首页的部分样式
.home_importNewsFoot {
    width: 100%;
    margin-top: 14px;
    position: relative;
    margin-bottom: 10px;

    a {
        color: #1c88d0;
        font-size: 13px;
        width: 96px;
        display: inline-block;
    }

    p {
        margin-bottom: 5px;
        margin-top: 5px;
        color: #898989;
        font-family: PingFang-SC-Medium;
        font-weight: SC-Medium;
        font-size: 12px;
        position: absolute;
        right: 0;
        display: inline-block;

        span {
            margin-right: 13px;
        }

        img {
            margin-right: 1px;
            width: 14px;
            height: 12px;
            display: inline-block;
        }
    }
}

.i_type {
    font-family: PingFang-SC-Bold;
    display: inline-block;
    font-weight: bold;
    margin-right: 5px;
    color: #c7000a;
}

.vedio_img {
    width: 31%;
    height: 100%;
    position: relative;
    img {
        width: 100% !important;
    }
    .vedio_play {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -20px;
        margin-top: -20px;
        width: 40px !important;
        height: 40px !important;
    }
    .vedio_time {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 60px !important;
        height: 23px !important;
        padding-left: 10px;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 14px !important;
        i {
            font-style: normal;
            padding-left: 5px;
        }
    }
    .vedio_time_icon {
        width: 17px !important;
        height: 17px !important;
    }
}
</style>